import { get } from 'lodash';
import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const IconWrapper = styled.div `
  ${({ $size }) => $size && `--falcon-size: ${pxToRem($size)};`}
  ${({ $color }) => $color && `--falcon-color: ${get(theme, $color)};`}
`;
